/**
 * Static navigation links for SEO purposes.
 * These links are rendered server-side for search engine crawlers.
 */
export interface StaticNavLink {
    label: string;
    href: string;
}

export const staticNavLinks: StaticNavLink[] = [
    { label: "Home", href: "/" },
    { label: "Unlisted Shares", href: "/unlisted-shares" },
    { label: "Refer", href: "/refer" },
    // { label: "Learn", href: "/learn" },
    { label: "About", href: "/about" },
    // { label: "Media", href: "/media" },
];

export const authLinks: StaticNavLink[] = [
    { label: "Login", href: "/login" },
    { label: "Sign up", href: "/signup" },
];
